import { render, staticRenderFns } from "./JobDescriptionForm.vue?vue&type=template&id=be3db3d2&"
import script from "./JobDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports